<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Admin Profile" subTitle="Admin" />

    <AdminProfile />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import AdminProfile from "@/components/Pages/General/AdminProfile.vue";

export default defineComponent({
  name: "AdminProfilePage",
  components: {
    PageTitle,
    AdminProfile,
  },
});
</script>
